import React, { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppFab from "./WhatsAppFab";
import CatalogBuilderBar from "./CatalogBuilderBar";
import { setupReveal } from "../../lib/constants";

export default function StorefrontLayout({ children }) {
  // Run once for the whole storefront. It watches the DOM, so sections that
  // mount later (async products, banners, blogs) are picked up automatically —
  // previously only Home set this up, so .reveal blocks on other pages stayed
  // invisible.
  useEffect(() => setupReveal(), []);

  return (
    <div className="min-h-screen bg-pearl flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <WhatsAppFab />
      <CatalogBuilderBar />
    </div>
  );
}
